import {Map, View, Feature} from "ol";
import {WMTS, Vector} from 'ol/source';
import * as extent from 'ol/extent';
import {default as WMTSTileGrid} from 'ol/tilegrid/WMTS';
import {Tile, Vector as VectorLayer} from 'ol/layer'
import {GeoJSON} from "ol/format";
import * as proj from 'ol/proj';
import {register} from "ol/proj/proj4";
import * as coordinate from 'ol/coordinate';
import * as geom from 'ol/geom';
import * as style from 'ol/style';

export const ol = ({
    Map,
    Feature,
    source: {
        WMTS,
        Vector
    },
    extent,
    tilegrid: {
        WMTS: WMTSTileGrid
    },
    layer: {
        Tile,
        Vector: VectorLayer,
    },
    coordinate,
    format: {
        GeoJSON
    },
    geom,
    View,
    proj: {
        ...proj,
        proj4: {
            register
        }
    },
    style
});

export function proj4() {
    return window.proj4
        ? [[
            'proj',
            new Promise(resolve => {
                resolve(window.proj4);
            })
        ]]
        : [];
}